/* eslint-disable */
import React from "react";

/**
 * Skeleton matching the Loans / Mart / Unions / Inventory dashboard layout:
 * an optional quick-actions row, a grid of stat cards, and a recent-records
 * table. Uses the global `.gskel` shimmer (transform-based, so it keeps
 * animating while the main thread is busy).
 *
 * variant "stacked"    -> icon circle top-left, link top-right, title + value
 *         "horizontal" -> icon box left, label + value beside it
 */
function DashboardListSkeleton({
  cards = 8,
  cols = 6,
  rows = 5,
  variant = "stacked",
  actions = 0,
}) {
  const gridCols = { gridTemplateColumns: `repeat(${cols}, 1fr)` };

  return (
    <div aria-busy="true" aria-label="Loading dashboard">
      {/* QUICK ACTIONS */}
      {actions > 0 && (
        <div className="flex flex-wrap gap-3 mb-6">
          {Array.from({ length: actions }).map((_, i) => (
            <span key={i} className="gskel" style={{ width: 150, height: 42, borderRadius: 8 }} />
          ))}
        </div>
      )}

      {/* STATS GRID */}
      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
        {Array.from({ length: cards }).map((_, i) =>
          variant === "horizontal" ? (
            <div
              key={i}
              className="bg-white dark:bg-gray-800 p-5 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm flex items-center gap-4"
            >
              <span className="gskel" style={{ width: 48, height: 48, borderRadius: 12, flexShrink: 0 }} />
              <div className="flex-1">
                <span className="gskel" style={{ width: "60%", height: 11, marginBottom: 10 }} />
                <span className="gskel" style={{ width: "45%", height: 22 }} />
              </div>
            </div>
          ) : (
            <div
              key={i}
              className="bg-white dark:bg-gray-800 p-4 rounded-2xl border border-slate-100 dark:border-gray-700 shadow-sm"
            >
              <div className="flex justify-between items-start mb-4">
                <span className="gskel" style={{ width: 48, height: 48, borderRadius: 9999 }} />
                <span className="gskel" style={{ width: 60, height: 12 }} />
              </div>
              <span className="gskel" style={{ width: "60%", height: 12, marginBottom: 10 }} />
              <span className="gskel" style={{ width: "40%", height: 24 }} />
            </div>
          )
        )}
      </section>

      {/* RECENT RECORDS TABLE */}
      <section className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-slate-100 dark:border-gray-700 overflow-hidden">
        <div className="p-6 border-b border-slate-50 dark:border-gray-700 flex justify-between items-center">
          <span className="gskel" style={{ width: 200, height: 16 }} />
          <span className="gskel" style={{ width: 60, height: 12 }} />
        </div>

        <div className="p-2">
          <div className="grid gap-4 px-4 py-3" style={gridCols}>
            {Array.from({ length: cols }).map((_, c) => (
              <span key={c} className="gskel" style={{ height: 14 }} />
            ))}
          </div>
          {Array.from({ length: rows }).map((_, r) => (
            <div
              key={r}
              className="grid gap-4 px-4 py-4 border-t border-slate-50 dark:border-gray-700"
              style={gridCols}
            >
              {Array.from({ length: cols }).map((_, c) => (
                <span key={c} className="gskel" style={{ height: 14 }} />
              ))}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default DashboardListSkeleton;
